//import {DOCUMENT} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {LocationHistoryUtils} from './location-history-utils';
import { KeycloakService } from "keycloak-angular";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'logout',
  template: ``,
})
export class LogoutPageComponent implements OnInit {
  constructor(
    private locationHistoryUtils: LocationHistoryUtils,
    private keycloak: KeycloakService,
  ) {}

  ngOnInit(): void {
    // Prevent back button hijacking from /logout in history
    this.locationHistoryUtils.replaceStateWithPreviousUrl({
      skipUrlsStartingWith: '/logout',
    });
    this.keycloak.logout(environment.edcUiLogoutUrl);
  }
}
